/**
 * Purpose:
 *   Tailwind CSS class constants for the Header component.
 *
 * Notes:
 *   - Uses gradient background token (bg-header) applied in the component
 *   - Supports responsive desktop/mobile layout variants
 */

export const headerStyles = {
  base: `
    w-full h-16 flex items-center justify-between pr-4 pl-8
    fixed top-0 left-0 right-0 z-50
  `,

  logoContainer: `
    flex items-center gap-4
  `,

  portalName: `
    text-white font-medium hidden desktop:block
  `,

  actionsContainer: `
    flex items-center gap-3
  `,

  hamburgerButton: `
    desktop:hidden p-1.5 -ml-2 text-white h-full flex items-center justify-center
    hover:bg-white/10 rounded-lg transition-colors
  `,
};
